<template>
  <div class="blog__section">Blog content will be added later...</div>
</template>

<script>
export default {
  name: "Blog",
};
</script>

<style scoped>
.blog__section {
  text-align: center;
  font-weight: bold;
  min-height: 50vh;
  font-size: 22px;
}
</style>
